/* CUSTOM 2026-08-05 / erweitert 2026-08-07 — Sprungmarken mit Nachfuehrung.

   Zwei Ausloeser:
     [data-scroll-to-reviews]  Sterne auf der Produktseite -> Judge.me-Block
     [data-jump-anchor]        Button im Kollektions-Banner -> Section auf derselben Seite

   Warum ueberhaupt JavaScript: Der Sprung selbst steckt im Markup (href="#…") und funktioniert
   auch ohne. Das Problem ist, WAS WAEHREND des Scrollens passiert — Bilder ohne feste Hoehe
   laden nach, die Einblende-Animationen der Sections geben Hoehe frei, Widgets bauen sich erst
   im Browser auf. Alles zwischen Klickposition und Ziel wird dadurch hoeher, das Ziel rutscht
   nach unten, der Browser scrollt aber zu der Position, die beim Klick galt. Man landet zu
   weit oben. Beim zweiten Klick stimmt es, weil dann alles geladen ist.

   Loesung: nach dem Sprung wird die Zielposition kurz nachgemessen und bei Abweichung
   korrigiert. Sobald der Nutzer selbst scrollt, wird sofort abgebrochen — es soll niemandem
   das Scrollrad aus der Hand genommen werden.

   Kein globales "scroll-behavior: smooth" am <html>: das wuerde auch alle uebrigen
   Sprungmarken und die Seitenuebergaenge des Themes betreffen.
*/
(() => {
  if (window.__customAnchorScroll) return;
  window.__customAnchorScroll = true;

  /* Judge.me benennt sein Widget je nach Widget-Typ unterschiedlich. Die Reihenfolge geht von
     der genauesten zur allgemeinsten Kennung. */
  const BEWERTUNGS_SELEKTOREN = '#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg';

  /* Wie lange nachgefuehrt wird. Lang genug fuer nachladende Bilder und Widgets, kurz genug,
     dass die Seite sich danach nicht mehr "von allein" bewegt. */
  const NACHFUEHR_DAUER = 2500;
  const PRUEF_ABSTAND = 200;
  const TOLERANZ = 4;

  const zielSuchen = (ausloeser) => {
    if (ausloeser.matches('[data-scroll-to-reviews]')) {
      return document.querySelector(BEWERTUNGS_SELEKTOREN);
    }

    const verweis = ausloeser.getAttribute('href') || '';
    if (!verweis.startsWith('#') || verweis.length < 2) return null;

    /* Kennungen aus dem Theme-Editor koennen Zeichen enthalten, die als CSS-Auswahl ungueltig
       waeren — deshalb ueber die Kennung suchen, nicht ueber querySelector. */
    return document.getElementById(decodeURIComponent(verweis.slice(1)));
  };

  const hinScrollen = (ziel) => {
    /* Der Versatz unter die Kopfzeile steht als scroll-margin-top am Ziel. Von dort gelesen,
       statt ihn hier zu wiederholen. */
    const versatz = parseFloat(getComputedStyle(ziel).scrollMarginTop) || 0;
    const sollPosition = () => window.scrollY + ziel.getBoundingClientRect().top - versatz;

    let abgebrochen = false;
    const abbrechen = () => {
      abgebrochen = true;
    };

    /* Nur echte Nutzereingaben brechen ab. Ein 'scroll'-Ereignis waere ungeeignet, das loest
       das weiche Scrollen selbst dauernd aus. */
    const eingaben = ['wheel', 'touchmove', 'keydown'];
    eingaben.forEach((typ) => window.addEventListener(typ, abbrechen, { passive: true }));

    window.scrollTo({ top: sollPosition(), behavior: 'smooth' });

    const start = performance.now();
    const nachfuehren = () => {
      if (abgebrochen || performance.now() - start > NACHFUEHR_DAUER) {
        eingaben.forEach((typ) => window.removeEventListener(typ, abbrechen));
        return;
      }

      const soll = sollPosition();
      if (Math.abs(window.scrollY - soll) > TOLERANZ) {
        window.scrollTo({ top: soll, behavior: 'smooth' });
      }

      setTimeout(nachfuehren, PRUEF_ABSTAND);
    };

    setTimeout(nachfuehren, PRUEF_ABSTAND);

    /* Adresszeile mitfuehren, damit der Zurueck-Knopf und das Teilen des Links funktionieren. */
    if (ziel.id) {
      history.replaceState(null, '', `#${ziel.id}`);
    }
  };

  /* CUSTOM 2026-09-15 — Anleitung per Link aufklappen.
     Die Anleitungs-Suche (/pages/manual, Flyer-QR-Code) verlinkt auf produkt-url#manual-anchor.
     Der Browser springt zwar zur Zeile, sie bleibt aber zu — die PDF-Schaltflaeche liegt darin.
     Deshalb hier aufklappen und mit der Nachfuehrung von oben hinscrollen: Das Aufklappen selbst
     aendert die Hoehe, und die Produktbilder darueber laden oft noch nach.
     `details.open = true` statt setAttribute: Das Theme-Element <details is="accordion-details">
     faengt die Eigenschaft ab und oeffnet mit seiner eigenen Animation. */
  const anleitungOeffnen = () => {
    if (!window.location.hash.includes('manual-anchor')) return;
    const ziel = document.getElementById('manual-anchor');
    if (!ziel) return;
    const details = ziel.querySelector('details');
    if (details && !details.open) details.open = true;
    hinScrollen(ziel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', anleitungOeffnen, { once: true });
  } else {
    anleitungOeffnen();
  }

  document.addEventListener('click', (event) => {
    const ausloeser = event.target.closest('[data-scroll-to-reviews], [data-jump-anchor]');
    if (!ausloeser) return;

    /* Immer abfangen: Fehlt das Ziel, wuerde der Browser den leeren Anker anspringen und den
       Nutzer an den Seitenanfang werfen. */
    event.preventDefault();

    const ziel = zielSuchen(ausloeser);
    if (!ziel) return;

    hinScrollen(ziel);
  });
})();
